/* Product form (PDP-01/03/05). Variant swap through the Section Rendering API,
   quantity-tier sticky summary and the mobile sticky buy bar (D-12).
   Same-origin fetch only; nodes are swapped by data-swap key, never through
   markup strings. Without JS the form still posts the chosen id and quantity. */
(function () {
  if (window.ThemeProductForm) return;

  var SWAP_KEYS = ['price', 'tiers', 'sticky', 'notify'];
  var token = 0;
  var ctaAbove = false;

  function sectionUrl(path, variantId, sectionId) {
    if (!/^\d+$/.test(String(variantId || ''))) return null;
    return path + '?variant=' + variantId + '&section_id=' + encodeURIComponent(sectionId);
  }

  /* Replace nodes of currentRoot by the node with the same data-swap key in
     newRoot. Nodes without a counterpart stay untouched. */
  function swapKeys(currentRoot, newRoot, only) {
    var done = [];
    var nodes = currentRoot.querySelectorAll('[data-swap]');
    for (var i = 0; i < nodes.length; i++) {
      var key = nodes[i].dataset.swap;
      if (only && only.indexOf(key) === -1) continue;
      var next = newRoot.querySelector('[data-swap="' + key + '"]');
      if (!next) continue;
      nodes[i].replaceWith(next);
      done.push(key);
    }
    return done;
  }

  /* Keep the chosen tier after a swap when it still exists, else 1 szt. */
  function restoreQuantity(root, value) {
    var radio = root.querySelector('input[name="quantity"][value="' + value + '"]');
    if (!radio) {
      value = '1';
      radio = root.querySelector('input[name="quantity"][value="1"]');
    }
    if (radio) radio.checked = true;
    return value;
  }

  function stickyAction(variantAvailable) {
    return variantAvailable ? 'submit' : 'scroll';
  }

  function stickySummary(root) {
    var checked = root.querySelector('input[name="quantity"]:checked');
    if (checked && checked.dataset && checked.dataset.tierLabel) {
      return { quantity: checked.dataset.tierLabel, total: checked.dataset.tierTotal };
    }
    var summary = root.querySelector('[data-sticky-summary]');
    var price = root.querySelector('.product__price .price__current');
    return {
      quantity: (summary && summary.dataset && summary.dataset.defaultLabel) || '1 szt.',
      total: price ? price.textContent.trim() : ''
    };
  }

  function scopeFor(form) {
    return form.closest('.shopify-section') || document;
  }

  function updateSummary(scope) {
    var el = scope.querySelector('[data-sticky-summary]');
    if (!el) return;
    var s = stickySummary(scope);
    el.textContent = s.quantity + ' - ' + s.total;
  }

  function applySticky(scope) {
    var bar = scope.querySelector('[data-sticky-bar]');
    if (bar) bar.classList.toggle('is-visible', ctaAbove);
    document.body.classList.toggle('has-sticky-bar', ctaAbove && !!bar);
  }

  function observeCta(form, scope) {
    var cta = form.querySelector('button[name="add"]');
    if (!cta) return;

    function update(above) {
      if (above === ctaAbove) return;
      ctaAbove = above;
      applySticky(scope);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        update(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(cta);
    }

    /* Fast flings and jumps can skip the observer; a passive check that only
       reads one rect keeps the bar correct. */
    window.addEventListener(
      'scroll',
      function () {
        update(cta.getBoundingClientRect().bottom < 0);
      },
      { passive: true }
    );
  }

  function currentVariantId(form) {
    var el = form.querySelector('input[name="id"]:checked') || form.querySelector('select[name="id"]');
    return el ? el.value : null;
  }

  function mediaIdFor(form) {
    var el = form.querySelector('input[name="id"]:checked');
    if (!el) {
      var select = form.querySelector('select[name="id"]');
      el = select && select.options[select.selectedIndex];
    }
    return el && el.dataset ? el.dataset.mediaId : null;
  }

  /* The observed CTA node is never replaced: copy state in place (Pitfall 9). */
  function syncBuy(form, parsed) {
    var current = form.querySelector('button[name="add"]');
    var next = parsed.querySelector('[data-swap="buy"]');
    if (!current || !next) return;
    if (window.CartAPI && window.CartAPI.buttonReset) window.CartAPI.buttonReset(current);
    current.textContent = next.textContent.trim();
    current.disabled = next.disabled;
    current.className = next.className;
  }

  function swapVariant(form) {
    var variantId = currentVariantId(form);
    var sectionId = form.dataset.sectionId;
    var url = sectionUrl(window.location.pathname, variantId, sectionId);
    if (!url || !window.fetch || !window.DOMParser) return;

    var scope = scopeFor(form);
    var checked = form.querySelector('input[name="quantity"]:checked');
    var quantity = checked ? checked.value : '1';
    var mine = ++token;

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('swap failed');
        return res.text();
      })
      .then(function (html) {
        if (mine !== token) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        swapKeys(scope, parsed, SWAP_KEYS);
        syncBuy(form, parsed);
        restoreQuantity(scope, quantity);
        updateSummary(scope);
        applySticky(scope);

        window.history.replaceState(null, '', '?variant=' + variantId);
        var mediaId = mediaIdFor(form);
        if (mediaId && window.ProductGallery) window.ProductGallery.showMedia(mediaId);
      })
      .catch(function () {
        /* leave the page as is; the form still posts the radio values */
      });
  }

  function scrollToPicker(scope) {
    var picker = scope.querySelector('[data-variant-picker]');
    if (!picker) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    picker.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
    var first = picker.querySelector('input:not([disabled]), select');
    if (first) first.focus({ preventScroll: true });
  }

  function init() {
    var form = document.getElementById('ProductForm');
    if (!form || form.dataset.productFormReady) return;
    form.dataset.productFormReady = 'true';
    var scope = scopeFor(form);

    form.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.name) return;
      if (target.name === 'id') swapVariant(form);
      else if (target.name === 'quantity') updateSummary(scope);
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-scroll-to-picker]');
      if (trigger) scrollToPicker(scope);
    });

    observeCta(form, scope);
  }

  window.ThemeProductForm = {
    sectionUrl: sectionUrl,
    swapKeys: swapKeys,
    restoreQuantity: restoreQuantity,
    stickyAction: stickyAction,
    stickySummary: stickySummary
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
